import { extend } from 'flarum/extend';
import PostUser from 'flarum/forum/components/PostUser';
import BadgeModal from './components/BadgeModal';
import UserBadge from '../common/components/UserBadge';

export default function addDiscussionUserBadge() {
  extend(PostUser.prototype, 'view', function(list){
    if(!this.attrs.post.data.relationships.user)
      return;
    const userID = this.attrs.post.data.relationships.user.data.id;
    const user = this.attrs.post.store.data.users[userID];

    if (!app.forum.attribute('showBadgesInDiscussion') || !user.userBadges) return;

    const userBadges = user.userBadges() ?? [];

    if (userBadges.length < 1 || !userBadges) return;

    const limit = app.forum.attribute('numberOfBadgesOnUserCard');
    let visibleBadges = userBadges.filter((userBadge) => {
      return userBadge.inUserCard();
    });

    if (visibleBadges.length === 0) {
      visibleBadges = userBadges.slice(0, limit);
    }

    const badges = visibleBadges.map((userBadge) => {
      return (
        <UserBadge
          badge={userBadge.badge()}
          onclick={() =>
            app.modal.show(BadgeModal, {
              badge: userBadge.badge(),
              userBadgeData: userBadge,
            })
          }
        />
      );
    });

    if(badges.length>0){
      for(let i=0;i<badges.length;i++){
        list.children.push(badges[i]);
      }
    }
  });
}
